import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: ({ context }) => {
    if (context.session?.isAuthenticated) {
      throw redirect({ to: "/participations" });
    }
    throw redirect({ to: "/login" });
  },
});
